import { render, staticRenderFns } from "./mediateSupplement_center.vue?vue&type=template&id=044a30f6&scoped=true&"
import script from "./mediateSupplement_center.vue?vue&type=script&lang=js&"
export * from "./mediateSupplement_center.vue?vue&type=script&lang=js&"
import style0 from "./mediateSupplement_center.vue?vue&type=style&index=0&id=044a30f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a30f6",
  null
  
)

export default component.exports